<script>
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import Store from '@/store/index.js'
import {getTeamIdsByUserId, getTeamsByTeamIds, hasInvitedMemberInTeam, addExternalMenmberToTeam, getOwnerTeamIds, includeUserIdInTeam} from '@/api/FirebaseTeamWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserData, getUserData } from '@/api/FirebaseUserWrapper.js'
import { hasAdminRole } from '@/api/Utilities.js'
const auth = getAuth(firebaseApp)
const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')

export default {
  components: {
    modalWindow
  },
  data () {
    return {
      profileUserData: {},
      twitterUrl: '',
      loginUserId: '',
      targetedTeams: [],
      profileUser: this.$route.params.userId, // 開いているページのuserId
      isCreated: false, // created()が終わったら true. falseの間はユーザー情報は表示しない
      teamSettingActive: false,
      showExternalMsg: true,
      alertExternalMsg: '',
      isAnonymousModal: false,
      isAnonymous: false,
      showPasswordSetting: false, // passwordの設定画面を開く
      oldPassword: '', // 現在のpassword
      newPassword: '', // 新しいpassword
      confirmedPassword: '',
      alertPasswordMsg: '', // passowordのアラート文章
      isPasswordLogin: '', // logintypeがpasswordのユーザ
      inputType: 'password', // 'password' or 'text'
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    await this.showProfile()
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  watch: {
    async $route (to, from) {
      // ルートの変更の検知...user/:A to user/:Bの際に画面描画されないため
      if (from.path !== to.path) {
        await this.showProfile()
      }
    }
  },
  methods: {
    async showProfile () {
      // 初期化
      this.profileUser = this.$route.params.userId
      const [loginUserData, profileUserData] = await Promise.all([getMyUserData(), getUserData(this.profileUser)])
      this.loginUserId = loginUserData.id
      this.isAnonymous = loginUserData.isAnonymous
      this.profileUserData = profileUserData
      this.isPasswordLogin = (auth.currentUser.providerData[0].providerId === 'password')
      document.title = 'プロフィール | ' + this.title
      document.querySelector("meta[property='og:title']").setAttribute('content', 'プロフィール | ' + this.title)
      // =================== GOOGLE ANALYTICS ===================
      if (hasAdminRole(this.loginUserId)) {
        console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
      } else {
        logEvent(analytics, 'profile/Profile')
        logEvent(analytics, 'profile_view', {
          profile_id: this.profileUser
        })
      }
      // userDataがnullならProfile部分をcreateしない
      if (!this.profileUserData) {
        this.isCreated = false
        return
      }
      this.twitterUrl = this.profileUserData.twitterName ? 'https://twitter.com/' + this.profileUserData.twitterName : ''
      this.isCreated = true
    },
    async clickTeamSetting () {
      // 表示しているloginユーザが所属しているチームIds
      const myTeamIds = await getTeamIdsByUserId(this.loginUserId)
      // ownerのteamを取得
      const ownerTeamIds = await getOwnerTeamIds(myTeamIds)
      // 招待可能なチームの情報を取得
      this.targetedTeams = await getTeamsByTeamIds(ownerTeamIds)
      this.teamSettingActive = true
      this.showExternalMsg = false
    },
    settingCloseModal () {
      this.teamSettingActive = false
    },
    closeAnonymousModal () {
      this.isAnonymousModal = false
    },
    clickSetViewingPage () {
      if (!this.profileUser) { return }
      let path = '/profile/' + this.profileUser
      Store.commit('setViewingPage', path)
    },
    async addExternalUser (teamId, teamName) {
      const isInTeam = await includeUserIdInTeam(teamId, this.profileUser)
      if (isInTeam) {
        this.showExternalMsg = true
        this.alertExternalMsg = 'ユーザーは既にチームに参加しています'
        return
      }
      const hasInvitation = await hasInvitedMemberInTeam(teamId, this.profileUser)
      if (hasInvitation) {
        this.showExternalMsg = true
        this.alertExternalMsg = 'ユーザーは既に招待済みです'
        return
      }
      try {
        await addExternalMenmberToTeam(teamId, teamName, '', this.profileUser, this.loginUserId, false)
        this.showExternalMsg = true
        this.alertExternalMsg = '招待メールをお送りしました'
      } catch (err) {
        console.log(err)
        this.showExternalMsg = true
        this.alertExternalMsg = '失敗しました'
      }
    },
    clickPasswordSetting () {
      this.showPasswordSetting = !this.showPasswordSetting
    },
    async updateNewPassword () {
      this.alertPasswordMsg = ''
      if (this.newPassword.length <= 5) {
        this.alertPasswordMsg = 'passwordが短すぎます'
        return
      }
      if (this.newPassword !== this.confirmedPassword) {
        this.alertPasswordMsg = '確認passwordが一致しません'
        return
      }
      if (this.oldPassword === this.newPassword) {
        this.alertPasswordMsg = 'passwordが変わっていません'
        return
      }
      const currentUser = auth.currentUser
      const authCredential = EmailAuthProvider.credential(currentUser.email, this.oldPassword)
      // 認証情報の更新(ログインしっぱなしで最近ログインしていないと無効化されている)
      try {
        await reauthenticateWithCredential(currentUser, authCredential)
      } catch (error) {
        console.error(error)
        this.alertPasswordMsg = '現在のpasswordが間違っています'
        return
      }
      // パスワードの更新
      try {
        await updatePassword(currentUser, this.newPassword)
        this.alertPasswordMsg = '更新に成功しました。新しいパスワードをお使いいただけます'
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmedPassword = ''
      } catch (error) {
        console.log(error)
        this.alertPasswordMsg = '更新に失敗しました'
      }
    },
    switchType () {
      this.inputType = (this.inputType === 'password') ? 'text' : 'password'
    }
  }
}
</script>
<style scoped>
.profile {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
.subtitle {
  margin-top: 0.25rem
}
.add-margin {
  margin-bottom: 0.5rem !important;
}
.intro {
  white-space: pre-wrap;
  word-break: break-all;
}
a:hover{
  text-decoration: underline;
}
.change-password {
  margin: auto;
  max-width: 400px;
}
.control .icon {
  pointer-events: all;
}
</style>
<template>
<div class='profile'>

  <div class="card is-shadowless" v-if="isCreated">
    <div class="card-content">
      <div class="media is-marginless add-margin">
        <div class="media-left" v-if = "loginUserId === this.profileUser">
          <router-link to="/editprofile">
            <figure class="image is-96x96">
              <img class="is-rounded" :src="profileUserData.imageUrl" alt="No image">
            </figure>
            <p class="subtitle has-text-centered is-size-8">@{{ profileUserData.name }}</p>
          </router-link>
        </div>
        <div class="media-left" v-else>
            <figure class="image is-96x96">
              <img class="is-rounded" :src="profileUserData.imageUrl" alt="No image">
            </figure>
            <p class="subtitle has-text-centered is-size-8">@{{ profileUserData.name }}</p>
        </div>
        <div class="media-content">
          <div class="content">
            <div class="buttons has-addons is-right" v-if="loginUserId === this.profileUser">
              <router-link to="/editprofile">
                <button class="button is-link is-rounded">
                  <span class="icon is-small">
                    <i class="fa-solid fa-user"></i>
                  </span>
                  <span>Profileを編集</span>
                </button>
              </router-link>
            </div>
            <div class="buttons has-addons is-right" v-if="loginUserId === this.profileUser">
              <router-link to="/myteams">
                <button class="button is-link is-rounded">
                  <span class="icon is-small">
                    <i class="fa-solid fa-users-cog"></i>
                  </span>
                  <span>チームの管理</span>
                </button>
              </router-link>
            </div>
            <div class="buttons has-addons is-right" v-else>
              <button class="button is-success is-rounded" @click="clickTeamSetting()">
                <span class="icon is-small">
                  <i class="fa-solid fa-users-cog"></i>
                </span>
                <span>チームへ招待</span>
              </button>
            </div>
            <div class="buttons has-addons is-right" v-if="loginUserId === this.profileUser && isPasswordLogin">
              <button class="button is-link is-rounded" @click="clickPasswordSetting()">
                <span class="icon is-small">
                  <i class="fa-solid fa-key"></i>
                </span>
                <span>パスワード</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="intro has-text-left is-size-7 add-margin">
        <p v-html="profileUserData.introduction"></p>
      </div>
      <div class="link has-text-left is-size-7 add-margin">
        <div v-if="profileUserData.twitterName">
          <span class="icon is-small is-left">
            <i class="fa-brands fa-twitter"></i>
          </span>
          <a v-bind:href="twitterUrl" target="_blank">{{profileUserData.twitterName}}</a>
        </div>
        <div v-if="profileUserData.url">
          <span class="icon is-small is-left">
            <i class="fa-solid fa-link"></i>
          </span>
          <a v-bind:href="profileUserData.url" target="_blank">{{profileUserData.url}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="change-password" v-if="showPasswordSetting && (loginUserId === this.profileUser) && isPasswordLogin">
    <div class="field">
      <label class="label">現在のPassword</label>
      <p class="control has-icons-left has-icons-right">
        <input class="input" :type="inputType" placeholder="5文字以上" v-model="oldPassword">
        <span class="icon is-small is-left">
          <i class="fa-solid fa-lock"></i>
        </span>
        <span class="icon is-small is-right" @click="switchType()">
          <i class="fa-solid fa-eye" v-if="inputType==='password'"></i>
          <i class="fa-solid fa-eye-slash" v-else></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">新規のPassword</label>
      <p class="control has-icons-left has-icons-right">
        <input class="input" :type="inputType" placeholder="5文字以上" v-model="newPassword">
        <span class="icon is-small is-left">
          <i class="fa-solid fa-lock"></i>
        </span>
        <span class="icon is-small is-right" @click="switchType()">
          <i class="fa-solid fa-eye" v-if="inputType==='password'"></i>
          <i class="fa-solid fa-eye-slash" v-else></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">新規のPasswordの確認</label>
      <p class="control has-icons-left has-icons-right">
        <input class="input" :type="inputType" placeholder="5文字以上" v-model="confirmedPassword">
        <span class="icon is-small is-left">
          <i class="fa-solid fa-lock"></i>
        </span>
        <span class="icon is-small is-right" @click="switchType()">
          <i class="fa-solid fa-eye" v-if="inputType==='password'"></i>
          <i class="fa-solid fa-eye-slash" v-else></i>
        </span>
      </p>
    </div>
    <p class="help is-danger has-text-centered">{{alertPasswordMsg}}</p>
    <div class="button is-danger is-outlined has-text-weight-bold" v-on:click="updateNewPassword">
      &nbsp;
      &nbsp;
      <span>Passwordの更新</span>
      &nbsp;
      &nbsp;
    </div>
  </div>
  <div class="Setting-modal-window">
    <modalWindow @close="settingCloseModal()" v-if="teamSettingActive">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete" @click="settingCloseModal()"></button>
        </div>
      </template>
      <label class="label has-text-left">ユーザをチームに招待する</label>
      <br>
      <div v-if="!showExternalMsg">
        <div v-for="team in targetedTeams" :key = "team.id">
          <div class="field is-grouped">
            <p class="control is-expanded has-text-weight-bold">
              {{team.teamName}}
            </p>
            <p class="control">
              <a class="button is-link" @click="addExternalUser(team.id, team.teamName)">
                追加
              </a>
            </p>
          </div>
          <br>
        </div>
      </div>
      <template slot="footer">
        <div class="text has-text-danger has-text-centered" v-if="showExternalMsg">
          {{alertExternalMsg}}
        </div>
      </template>
    </modalWindow>
  </div>
  <div class="anonymous-modal-window">
    <modalWindow v-if="isAnonymousModal">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete" @click="closeAnonymousModal()"></button>
        </div>
      </template>
      <p>ログインするとフォローできますよ！</p>
      <template slot="footer">
        <router-link class="buttons is-centered" @click.native="clickSetViewingPage()" to="/login">
          <button class="button is-link">Loginページへ</button>
        </router-link>
        <br>
      </template>
    </modalWindow>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/profile/Profile.vue